export class BLAST_EMAIL {
    constructor(
        public BE_ID: number,
        public SUBJECT: string,
        public MESSAGE: string,
        public TIME_SCH: Date,
        public TIME_FINISH: Date,
        public LAST_INV_ID: number,
        public SENT_ITEMS: number,
        public CD_STATUS: string,
        public CREATED_BY: number,
        public D_CREATED: Date,
        public UPD_BY: number,
        public D_LAST_UPD: Date,
        public CONFIRM_BY: number,
        public D_CONFIRM: Date,
        public CC: string,
        public BCC: string,
        public FILTER: string
    ) { }
}
export class FILTER_INV {
    constructor(
        public INV_BY: string,
        public OPERATOR: string,
        public VALUE: string
    ) { }
}


// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/models/blastemail.ts